<template>
  <div class="title-block">
    Êtes-vous sûr de vouloir désactiver votre lien de campagne ?
  </div>
  <p class="under-text">
    En désactivant ce lien de campagne vous le rendrez inactif. Si vous le réactivez, un nouveau lien sera généré et l’ancien ne fonctionnera plus.
  </p>
  <div class="btn-container">
    <Button
      class="secondary outline"
      label="Conserver le lien"
      @click="emits('close')"
    />
    <Button
      class="primary"
      label="Désactiver le lien"
      :loading="state.btnIsLoading"
      @click="deactivateLink"
    />
  </div>
</template>

<script setup>
import { reactive } from "vue";

const emits = defineEmits(["close", "confirm"]);

const state = reactive({
  btnIsLoading: false,
});

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

async function deactivateLink() {
  state.btnIsLoading = true;

  emits("confirm");
}
</script>
